import React from 'react';

import ThreadView from './ThreadView';

const AxiumThreadView = (props) => (
  <ThreadView {...props} />
);

export default AxiumThreadView;
